package com.partejar.app.feature.home.data.remote

import com.partejar.app.core.network.ApiConfig
import com.partejar.app.core.session.CurrentWorkspaceRepository
import com.partejar.app.feature.home.data.HomeDataException
import com.partejar.app.feature.home.data.HomeDataSource
import com.partejar.app.feature.home.data.HomeDashboardData
import com.partejar.app.feature.home.data.HomeSessionExpiredException
import com.partejar.app.feature.home.data.HomeUnavailableException
import com.partejar.app.feature.home.data.HomeWorkspaceForbiddenException
import com.partejar.app.feature.home.data.HomeWorkspaceNotConfiguredException
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.http.HttpStatusCode
import kotlinx.coroutines.CancellationException

class HomeRemoteDataSource(
    private val client: HttpClient,
    private val apiConfig: ApiConfig,
    private val currentWorkspaceRepository: CurrentWorkspaceRepository,
    private val mapper: HomeRemoteMapper
) : HomeDataSource {

    override suspend fun loadHome(): HomeDashboardData {
        val workspaceId = currentWorkspaceRepository.currentWorkspaceId()
            ?: throw HomeWorkspaceNotConfiguredException()
        return try {
            val response = client.get(apiConfig.endpoint("/home")) {
                header(WORKSPACE_HEADER, workspaceId)
            }
            when (response.status) {
                HttpStatusCode.OK -> mapper.map(response.body<HomeResponseDto>())
                HttpStatusCode.Unauthorized -> throw HomeSessionExpiredException()
                HttpStatusCode.BadRequest -> throw HomeWorkspaceNotConfiguredException()
                HttpStatusCode.Forbidden -> throw HomeWorkspaceForbiddenException()
                else -> throw HomeUnavailableException()
            }
        } catch (exception: CancellationException) {
            throw exception
        } catch (exception: HomeDataException) {
            throw exception
        } catch (exception: Throwable) {
            throw HomeUnavailableException(exception)
        }
    }

    private companion object {
        const val WORKSPACE_HEADER = "X-Workspace-Id"
    }
}
